const listeners = new Set();

export const subscribeToFlashMessages = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const emitFlashMessage = (payload) => {
  listeners.forEach((listener) => listener(payload));
};

export const flashMessage = (text, options = {}) => {
  emitFlashMessage({ text, ...options });
};
